import Vue from 'vue'
import Vuex from 'vuex'

import user from './modules/user'
import brand from './modules/brand'

Vue.use(Vuex)

export default new Vuex.Store({
    modules: {
        user,
        brand
    }
})